import React from "react";
import {useThemeSelector} from "../redux/reducers/themeReducer";
import TooltipButton from "./TooltipButton/TooltipButton";
import {Button, Tooltip} from "antd";
import styled from "styled-components";

const IconContainer = styled.span`
    svg {
        font-size: 20px;
        margin-right: 10px;
    }
    button:disabled svg {            
        opacity: 0.6;
    }
    .ant-btn {
        margin-bottom: 10px;            
        margin-right: 10px;            
    }
`;

const GridActionIcon = props => {
    const {title, onClick, icon, darkIcon, disabled, useButtonInsteadOfIcon} = props;

    const {primaryColor, darkMode} = useThemeSelector();

    return darkMode ?
        <IconContainer><Tooltip title={title}>
            <Button disabled={disabled} icon={darkIcon} style={{color: primaryColor}} type='text' onClick={onClick}>
                {useButtonInsteadOfIcon && title }
            </Button>
        </Tooltip>
        </IconContainer> :
        <TooltipButton size='small' disabled={disabled} useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                       icon={icon}
                       title={title} onClick={onClick}/>
};

export default GridActionIcon;